import { useCallback, useContext, useEffect } from 'react'

import { goToLogin } from 'core/use-cases/goToLogin'

import { LoadBoardContext, LOAD_BOARD_ACTIONS } from 'legacy/contexts/loadBoard'
import { getCarrier } from 'legacy/services/carrier'
import { analytics } from 'legacy/utils/analytics'
import { sentry } from 'legacy/utils/sentry'
import { user } from 'legacy/utils/user'

const STATUS = {
  READY: 'ready',
}

function CarrierManager(props) {
  const { children } = props

  const [{ carrier }, dispatch] = useContext(LoadBoardContext)
  const { _isLoaded } = carrier || {}
  const isUserLoggedIn = user.isLoggedIn()

  const handleFetchCarrierSuccess = useCallback(
    carrierResponse => {
      const { data: carrierData } = carrierResponse.data
      const { contracting_requirements_passes, mc_number, status } = carrierData

      user.set('mcNumber', mc_number)
      user.set('verified', contracting_requirements_passes)

      dispatch({
        type: LOAD_BOARD_ACTIONS.UPDATE_CARRIER,
        payload: {
          ...carrierData,
          ready: status === STATUS.READY,
          _isLoading: false,
          _isLoaded: true,
        },
      })
    },
    [dispatch]
  )

  const handleFetchCarrierError = useCallback(
    async error => {
      const { response } = error || {}
      const { status, data } = response || {}
      const { error: errorMessage } = data || {}

      dispatch({
        type: LOAD_BOARD_ACTIONS.UPDATE_CARRIER,
        payload: {
          _isLoaded: true,
          _isLoading: false,
        },
      })

      if (status === 401 || errorMessage === 'invalid_access_token') {
        user.logout()
        goToLogin()
      }

      if (!status) {
        sentry.log(error)
      }

      analytics.track('Load Board / Carrier / Carrier Fetch Error', {
        description: error.response?.data?.detail,
        status: error.response?.status,
      })
    },
    [dispatch]
  )

  const updateCarrier = useCallback(async () => {
    dispatch({
      type: LOAD_BOARD_ACTIONS.UPDATE_CARRIER,
      payload: {
        _isLoading: true,
      },
    })

    try {
      if (isUserLoggedIn) {
        const response = await getCarrier()
        await handleFetchCarrierSuccess(response)
      } else {
        dispatch({
          type: LOAD_BOARD_ACTIONS.UPDATE_CARRIER,
          payload: {
            _isLoaded: true,
            _isLoading: false,
          },
        })
      }
    } catch (error) {
      handleFetchCarrierError(error)
    }
  }, [dispatch, handleFetchCarrierError, handleFetchCarrierSuccess, isUserLoggedIn])

  useEffect(() => {
    updateCarrier()
  }, [updateCarrier])

  if (!_isLoaded) {
    return null
  }

  return <>{children}</>
}

export { CarrierManager }
